import { tokenUtils } from '../utils/tokenUtils';

const API_BASE_URL = process.env.REACT_APP_API_URL + "/Video";

function getAuthHeaders(isJson = false) {
  const token = tokenUtils.get();
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  if (isJson) {
    headers["Content-Type"] = "application/json";
  }
  return headers;
}

export async function getVideos() {
  const response = await fetch(API_BASE_URL, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("Error al obtener los videos");
  }

  return response.json();
}

export const getVideoById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/${id}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("Error al obtener el video");
  }

  return response.json();
};

export async function createVideo(formData) {
  const response = await fetch(`${API_BASE_URL}/upload`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Error al subir el video");
  }

  return response.json();
}

export async function updateVideo(id, videoData) {
  // Determinar si es FormData o JSON
  const isFormData = videoData instanceof FormData;
  
  const response = await fetch(`${API_BASE_URL}/${id}`, {
    method: "PUT",
    headers: isFormData ? getAuthHeaders(false) : getAuthHeaders(true),
    body: isFormData ? videoData : JSON.stringify(videoData),
  });

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    let message = "Error al actualizar el video";
    try {
      const errorData = JSON.parse(text);
      message =
        errorData.message ||
        errorData.title ||
        (typeof errorData === "string" ? errorData : message);
    } catch {
      if (text) message = text;
    }
    throw new Error(message);
  }

  return response.json();
}

export async function deleteVideo(id) {
  const response = await fetch(`${API_BASE_URL}/${id}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("Error al eliminar el video");
  }

  return response.json();
}